import { Environment } from '@shared/interfaces/environment';
import { RoutesPath } from '@shared/enums/routes-path';
import { ServiceDetailRoutesPath } from '@cargeny/pages/services/enums/service-detail-routes-path';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';
import { ArticleDetailRoutesPath } from '@cargeny/pages/articles/enums/article-detail-routes-path';

export const environment: Environment = {
  production: true,
  langs: {
    fr: {
      host: 'cargeny.com',
      langs: ['fr', 'en'],
      defaultLang: 'fr',
      countryCode: ['fr'],
      plate: {
        code: 'f',
        placeholder: 'AB-123-CD',
      },
      api: {
        url: 'https://api.cargeny.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD3x-BEC9uo0V3zMtXRg1vC42iRJubvM8Q',
        },
      },
      sentry: {
        dsn: 'https://c4b4d0c88ebf8a7116d46770488346b9@o4508637161783296.ingest.de.sentry.io/4508698661617744',
      },
      config: {
        name: 'Cargeny',
        test: false,
        subscription: {
          name: 'Cargenious',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787211',
          vat: 'BG207787211',
          address: 'Jawaharlal Neru n.28, Silver Center, fl.2, office 64. 1324 Sofia, Bulgaria',
          name: 'INOVATECH SOLUTIONS LTD',
        },
        partners: [
          {
            name: 'techcars',
            logo: '/assets/img/partners/partner-1.png',
          },
          {
            name: 'turbauto',
            logo: '/assets/img/partners/partner-2.png',
          },
          {
            name: 'roadup',
            logo: '/assets/img/partners/partner-3.png',
          },
          {
            name: 'autogo',
            logo: '/assets/img/partners/partner-4.png',
          },
        ],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'connexion',
        [RoutesPath.SIGN_UP]: 'inscription',
        [RoutesPath.UNSUBSCRIBE]: 'resiliation',
        [RoutesPath.FORGOT_PASSWORD]: 'mot-de-passe-oublie',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'contact',
        [RoutesPath.SERVICES]: 'examples',
        [RoutesPath.ARTICLES]: 'blog',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'dashboard',
        [RoutesPath.NOT_FOUND]: 'page-introuvable',
        [RoutesPath.ABOUT]: 'qui-sommes-nous',
        [RoutesPath.PREVIEW]: 'apercu-rapport',
        [RoutesPath.PAYMENT_INTENT]: 'paiement-etape-1',
        [RoutesPath.PAYMENT_VALIDATION]: 'paiement-etape-2',
        [RoutesPath.LOADING]: 'chargement-final',
        [RoutesPath.LOADING_PREVIEW]: 'chargement',
        [RoutesPath.PRICING]: 'prix',
        [RoutesPath.TESTIMONIALS]: 'temoignages-clients',
        [RoutesPath.SERVICE]: 'service',
        [RoutesPath.SSO]: 'autosession',
        [RoutesPath.CAR_NOT_FOUND]: 'voiture-introuvable',
        [RoutesPath.VIN]: '',
        [RoutesPath.COMPARE]: '',
        [RoutesPath.PARTNERS]: '',
        [RoutesPath.GLOSSARY]: '',
        [RoutesPath.COMPANY]: '',
        [RoutesPath.AFFILIATE]: '',
        [RoutesPath.LEASING]: '',
        [RoutesPath.INSURANCE]: '',
        [RoutesPath.CAREERS]: '',
        [RoutesPath.GUIDE]: '',
        [RoutesPath.PRESS]: '',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'mentions-legales',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politique-de-confidentialite',
        [GlobalRoutesPath.REFUND_POLICY]: 'politique-de-remboursement',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'conditions-generales',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'conditions-generales-de-vente',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'faq',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.REAL_TIME_VALUATION]: 'evaluation-en-temps-reel',
        [ServiceDetailRoutesPath.SALE_OF_A_VEHICLE]: 'vente-de-vehicule',
        [ServiceDetailRoutesPath.PURCHASE_OF_A_VEHICLE]: 'achat-de-vehicule',
      },
      articleRoutes: {
        [ArticleDetailRoutesPath.AUTOMOTIVE_MARKET_TRENDS_IN_2024_WHAT_DEALERS_NEED_TO_KNOW]:
          'automotive-market-trends-in-2024-what-dealers-need-to-know',
        [ArticleDetailRoutesPath.ECOLOGICAL_INITIATIVES_BY_CAR_MANUFACTURERS_TOWARD_SUSTAINABLE_COMMERCE]:
          'lessor-of-electric-vehicles-a-revolution-in-car-commerce',
        [ArticleDetailRoutesPath.LESSOR_OF_ELECTRIC_VEHICLES_A_REVOLUTION_IN_CAR_COMMERCE]:
          'ecological-initiatives-by-car-manufacturers-toward-sustainable-commerce',
        [ArticleDetailRoutesPath.THE_IMPACT_OF_DIGITALIZATION_ON_CAR_DEALERSHIPS]:
          'the-impact-of-digitalization-on-car-dealerships',
        [ArticleDetailRoutesPath.THE_SEMICONDUCTOR_SHORTAGE_IMPLICATIONS_FOR_THE_AUTOMOTIVE_INDUSTRY]:
          'the-semiconductor-shortage-implications-for-the-automotive-industry',
        [ArticleDetailRoutesPath.THE_USED_CAR_MARKET_OPPORTUNITIES_AND_CHALLENGES_FOR_AUTO_PROFESSIONALS]:
          'the-used-car-market-opportunities-and-challenges-for-auto-professionals',
      },
      automation: {
        addUserToEmailing: 'jc7mwvu5bbqud68k7f79pd1q19ssv58r',
        removeUserToEmailing: 'hctczp5c4vvgeuq14l7c9w9iqjgj0k9w',
      },
    },
    it: {
      host: 'cargeny.it',
      langs: ['it', 'en'],
      defaultLang: 'it',
      countryCode: ['it'],
      plate: {
        code: 'i',
        placeholder: 'AB-123CD',
      },
      api: {
        url: 'https://api.cargeny.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD3x-BEC9uo0V3zMtXRg1vC42iRJubvM8Q',
        },
      },
      sentry: {
        dsn: 'https://5f3c02fd3b6b1dad61f52233363d7a21@o4508637161783296.ingest.de.sentry.io/4508698665549904',
      },
      config: {
        name: 'Cargeny',
        test: false,
        subscription: {
          name: 'Cargenious',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787211',
          vat: 'BG207787211',
          address: 'Jawaharlal Neru n.28, Silver Center, fl.2, office 64. 1324 Sofia, Bulgaria',
          name: 'INOVATECH SOLUTIONS LTD',
        },
        partners: [
          {
            name: 'techcars',
            logo: '/assets/img/partners/partner-1.png',
          },
          {
            name: 'turbauto',
            logo: '/assets/img/partners/partner-2.png',
          },
          {
            name: 'roadup',
            logo: '/assets/img/partners/partner-3.png',
          },
          {
            name: 'autogo',
            logo: '/assets/img/partners/partner-4.png',
          },
        ],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'accesso',
        [RoutesPath.SIGN_UP]: 'registrazione',
        [RoutesPath.UNSUBSCRIBE]: 'disdetta',
        [RoutesPath.FORGOT_PASSWORD]: 'password-dimenticata',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'contatto',
        [RoutesPath.SERVICES]: 'servizi',
        [RoutesPath.ARTICLES]: 'blog',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'pannello-di-controllo',
        [RoutesPath.NOT_FOUND]: 'pagina-non-trovata',
        [RoutesPath.ABOUT]: 'chi-siamo',
        [RoutesPath.PREVIEW]: 'anteprima-rapporto',
        [RoutesPath.PAYMENT_INTENT]: 'pagamento-fase-1',
        [RoutesPath.PAYMENT_VALIDATION]: 'pagamento-fase-2',
        [RoutesPath.LOADING]: 'caricamento-finale',
        [RoutesPath.LOADING_PREVIEW]: 'caricamento',
        [RoutesPath.PRICING]: 'prezzi',
        [RoutesPath.TESTIMONIALS]: 'testimonianze-clienti',
        [RoutesPath.SERVICE]: 'servizio',
        [RoutesPath.SSO]: 'fastauth',
        [RoutesPath.CAR_NOT_FOUND]: 'auto-non-trovata',
        [RoutesPath.VIN]: '',
        [RoutesPath.COMPARE]: '',
        [RoutesPath.PARTNERS]: '',
        [RoutesPath.GLOSSARY]: '',
        [RoutesPath.COMPANY]: '',
        [RoutesPath.AFFILIATE]: '',
        [RoutesPath.LEASING]: '',
        [RoutesPath.INSURANCE]: '',
        [RoutesPath.CAREERS]: '',
        [RoutesPath.GUIDE]: '',
        [RoutesPath.PRESS]: '',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'note-legali',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politica-sulla-privacy',
        [GlobalRoutesPath.REFUND_POLICY]: 'politica-di-rimborso',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'termini-e-condizioni',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'condizioni-generali-di-vendita',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'domande-frequenti',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.REAL_TIME_VALUATION]: 'valutazione-in-tempo-reale',
        [ServiceDetailRoutesPath.SALE_OF_A_VEHICLE]: 'vendita-di-un-veicolo',
        [ServiceDetailRoutesPath.PURCHASE_OF_A_VEHICLE]: 'acquisto-di-un-veicolo',
      },
      articleRoutes: {
        [ArticleDetailRoutesPath.AUTOMOTIVE_MARKET_TRENDS_IN_2024_WHAT_DEALERS_NEED_TO_KNOW]:
          'tendenze-del-mercato-automobilistico-nel-2024-cosa-devono-sapere-i-concessionari',
        [ArticleDetailRoutesPath.ECOLOGICAL_INITIATIVES_BY_CAR_MANUFACTURERS_TOWARD_SUSTAINABLE_COMMERCE]:
          'iniziative-ecologiche-dei-produttori-di-auto-verso-un-commercio-sostenibile',
        [ArticleDetailRoutesPath.LESSOR_OF_ELECTRIC_VEHICLES_A_REVOLUTION_IN_CAR_COMMERCE]:
          'il-locatore-di-veicoli-elettrici-una-revoluzione-nel-commercio-delle-auto',
        [ArticleDetailRoutesPath.THE_IMPACT_OF_DIGITALIZATION_ON_CAR_DEALERSHIPS]:
          'l-impatto-della-digitalizzazione-sui-concessionari-auto',
        [ArticleDetailRoutesPath.THE_SEMICONDUCTOR_SHORTAGE_IMPLICATIONS_FOR_THE_AUTOMOTIVE_INDUSTRY]:
          'le-conseguenze-della-carenza-di-semiconduttori-per-l-industria-automobilistica',
        [ArticleDetailRoutesPath.THE_USED_CAR_MARKET_OPPORTUNITIES_AND_CHALLENGES_FOR_AUTO_PROFESSIONALS]:
          'il-mercato-delle-auto-usate-opportunità-e-sfide-per-i-professionisti-del-settore-auto',
      },
      automation: {
        addUserToEmailing: 'jc7mwvu5bbqud68k7f79pd1q19ssv58r',
        removeUserToEmailing: 'hctczp5c4vvgeuq14l7c9w9iqjgj0k9w',
      },
    },
    es: {
      host: 'cargeny.es',
      langs: ['es', 'en'],
      defaultLang: 'es',
      countryCode: ['es'],
      plate: {
        code: 'e',
        placeholder: '1234-ABC',
      },
      api: {
        url: 'https://api.cargeny.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD3x-BEC9uo0V3zMtXRg1vC42iRJubvM8Q',
        },
      },
      sentry: {
        dsn: 'https://cfd07c7446630e0ddc54907567280e85@o4508637161783296.ingest.de.sentry.io/4508698667778128',
      },
      config: {
        name: 'Cargeny',
        test: false,
        subscription: {
          name: 'Cargenious',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787211',
          vat: 'BG207787211',
          address: 'Jawaharlal Neru n.28, Silver Center, fl.2, office 64. 1324 Sofia, Bulgaria',
          name: 'INOVATECH SOLUTIONS LTD',
        },
        partners: [
          {
            name: 'techcars',
            logo: '/assets/img/partners/partner-1.png',
          },
          {
            name: 'turbauto',
            logo: '/assets/img/partners/partner-2.png',
          },
          {
            name: 'roadup',
            logo: '/assets/img/partners/partner-3.png',
          },
          {
            name: 'autogo',
            logo: '/assets/img/partners/partner-4.png',
          },
        ],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'iniciar-sesion',
        [RoutesPath.SIGN_UP]: 'registro',
        [RoutesPath.UNSUBSCRIBE]: 'cancelacion',
        [RoutesPath.FORGOT_PASSWORD]: 'olvido-contrasena',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'contacto',
        [RoutesPath.SERVICES]: 'servicios',
        [RoutesPath.ARTICLES]: 'blog',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'panel-de-control',
        [RoutesPath.NOT_FOUND]: 'pagina-no-encontrada',
        [RoutesPath.ABOUT]: 'quienes-somos',
        [RoutesPath.PREVIEW]: 'vista-previa-informe',
        [RoutesPath.PAYMENT_INTENT]: 'pago-paso-1',
        [RoutesPath.PAYMENT_VALIDATION]: 'pago-paso-2',
        [RoutesPath.LOADING]: 'cargando-final',
        [RoutesPath.LOADING_PREVIEW]: 'cargando',
        [RoutesPath.PRICING]: 'precios',
        [RoutesPath.TESTIMONIALS]: 'testimonios-clientes',
        [RoutesPath.SERVICE]: 'servicio',
        [RoutesPath.SSO]: 'quickauth',
        [RoutesPath.CAR_NOT_FOUND]: 'coche-no-encontrado',
        [RoutesPath.VIN]: '',
        [RoutesPath.COMPARE]: '',
        [RoutesPath.PARTNERS]: '',
        [RoutesPath.GLOSSARY]: '',
        [RoutesPath.COMPANY]: '',
        [RoutesPath.AFFILIATE]: '',
        [RoutesPath.LEASING]: '',
        [RoutesPath.INSURANCE]: '',
        [RoutesPath.CAREERS]: '',
        [RoutesPath.GUIDE]: '',
        [RoutesPath.PRESS]: '',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'aviso-legal',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politica-de-privacidad',
        [GlobalRoutesPath.REFUND_POLICY]: 'politica-de-reembolso',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'terminos-y-condiciones',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'condiciones-generales-de-venta',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'preguntas-frecuentes',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.REAL_TIME_VALUATION]: 'valoracion-en-tiempo-real',
        [ServiceDetailRoutesPath.SALE_OF_A_VEHICLE]: 'venta-de-un-vehiculo',
        [ServiceDetailRoutesPath.PURCHASE_OF_A_VEHICLE]: 'compra-de-un-vehiculo',
      },
      articleRoutes: {
        [ArticleDetailRoutesPath.AUTOMOTIVE_MARKET_TRENDS_IN_2024_WHAT_DEALERS_NEED_TO_KNOW]:
          'tendencias-del-mercado-automotriz-en-2024-lo-que-los-concesionarios-necesitan-saber',
        [ArticleDetailRoutesPath.ECOLOGICAL_INITIATIVES_BY_CAR_MANUFACTURERS_TOWARD_SUSTAINABLE_COMMERCE]:
          'iniciativas-ecologicas-de-los-fabricantes-de-automoviles-hacia-el-comercio-sostenible',
        [ArticleDetailRoutesPath.LESSOR_OF_ELECTRIC_VEHICLES_A_REVOLUTION_IN_CAR_COMMERCE]:
          'arrendador-de-vehiculos-electricos-una-revolucion-en-el-comercio-de-autos',
        [ArticleDetailRoutesPath.THE_IMPACT_OF_DIGITALIZATION_ON_CAR_DEALERSHIPS]:
          'el-impacto-de-la-digitalizacion-en-los-concesionarios-de-autos',
        [ArticleDetailRoutesPath.THE_SEMICONDUCTOR_SHORTAGE_IMPLICATIONS_FOR_THE_AUTOMOTIVE_INDUSTRY]:
          'la-escasez-de-semiconductores-implicaciones-para-la-industria-automotriz',
        [ArticleDetailRoutesPath.THE_USED_CAR_MARKET_OPPORTUNITIES_AND_CHALLENGES_FOR_AUTO_PROFESSIONALS]:
          'el-mercado-de-autos-usados-oportunidades-y-retos-para-los-profesionales-del-automovil',
      },
      automation: {
        addUserToEmailing: 'jc7mwvu5bbqud68k7f79pd1q19ssv58r',
        removeUserToEmailing: 'hctczp5c4vvgeuq14l7c9w9iqjgj0k9w',
      },
    },
    fi: {
      host: 'cargeny.fi',
      langs: ['fi', 'en'],
      defaultLang: 'fi',
      countryCode: ['fi'],
      plate: {
        code: 'fin',
        placeholder: 'ABC-D23',
      },
      api: {
        url: 'https://api.cargeny.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD3x-BEC9uo0V3zMtXRg1vC42iRJubvM8Q',
        },
      },
      sentry: {
        dsn: 'https://de03964f8b2af4f814644860f95eeaa2@o4508637161783296.ingest.de.sentry.io/4508698672234576',
      },
      config: {
        name: 'Cargeny',
        test: false,
        subscription: {
          name: 'Cargenious',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787211',
          vat: 'BG207787211',
          address: 'Jawaharlal Neru n.28, Silver Center, fl.2, office 64. 1324 Sofia, Bulgaria',
          name: 'INOVATECH SOLUTIONS LTD',
        },
        partners: [
          {
            name: 'techcars',
            logo: '/assets/img/partners/partner-1.png',
          },
          {
            name: 'turbauto',
            logo: '/assets/img/partners/partner-2.png',
          },
          {
            name: 'roadup',
            logo: '/assets/img/partners/partner-3.png',
          },
          {
            name: 'autogo',
            logo: '/assets/img/partners/partner-4.png',
          },
        ],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'kirjaudu-sisaan',
        [RoutesPath.SIGN_UP]: 'rekisteroidy',
        [RoutesPath.UNSUBSCRIBE]: 'peru-tilaus',
        [RoutesPath.FORGOT_PASSWORD]: 'unohtunut-salasana',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'yhteydenotto',
        [RoutesPath.SERVICES]: 'palvelut',
        [RoutesPath.ARTICLES]: 'blogi',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'hallintapaneeli',
        [RoutesPath.NOT_FOUND]: 'sivua-ei-loytynyt',
        [RoutesPath.ABOUT]: 'keita-olemme',
        [RoutesPath.PREVIEW]: 'raportin-esikatselu',
        [RoutesPath.PAYMENT_INTENT]: 'maksu-vaihe-1',
        [RoutesPath.PAYMENT_VALIDATION]: 'maksu-vaihe-2',
        [RoutesPath.LOADING]: 'lataus-lopullinen',
        [RoutesPath.LOADING_PREVIEW]: 'lataus',
        [RoutesPath.PRICING]: 'hinnat',
        [RoutesPath.TESTIMONIALS]: 'asiakasarviot',
        [RoutesPath.SERVICE]: 'palvelu',
        [RoutesPath.SSO]: 'magicauth',
        [RoutesPath.CAR_NOT_FOUND]: 'auto-ei-loytynyt',
        [RoutesPath.VIN]: '',
        [RoutesPath.COMPARE]: '',
        [RoutesPath.PARTNERS]: '',
        [RoutesPath.GLOSSARY]: '',
        [RoutesPath.COMPANY]: '',
        [RoutesPath.AFFILIATE]: '',
        [RoutesPath.LEASING]: '',
        [RoutesPath.INSURANCE]: '',
        [RoutesPath.CAREERS]: '',
        [RoutesPath.GUIDE]: '',
        [RoutesPath.PRESS]: '',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'oikeudellinen_ilmoitus',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'tietosuojakaytanto',
        [GlobalRoutesPath.REFUND_POLICY]: 'palautuskaytanto',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'kayttoehdot',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'myyntiehdot',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'usein_kysytyt_kysymykset',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.REAL_TIME_VALUATION]: 'reaaliaikainen_arviointi',
        [ServiceDetailRoutesPath.SALE_OF_A_VEHICLE]: 'ajoneuvon_myynti',
        [ServiceDetailRoutesPath.PURCHASE_OF_A_VEHICLE]: 'ajoneuvon_osto',
      },
      articleRoutes: {
        [ArticleDetailRoutesPath.AUTOMOTIVE_MARKET_TRENDS_IN_2024_WHAT_DEALERS_NEED_TO_KNOW]:
          'autoteollisuuden-markkinatrendit-2024-mita-jälleenmyyjien-tulee-tietaa',
        [ArticleDetailRoutesPath.ECOLOGICAL_INITIATIVES_BY_CAR_MANUFACTURERS_TOWARD_SUSTAINABLE_COMMERCE]:
          'sahkoautojen-vuokraus-uudistus-autokaupassa',
        [ArticleDetailRoutesPath.LESSOR_OF_ELECTRIC_VEHICLES_A_REVOLUTION_IN_CAR_COMMERCE]:
          'autovalmistajien-ekologiset-aloitteet-kestävän-kaupan-suuntaan',
        [ArticleDetailRoutesPath.THE_IMPACT_OF_DIGITALIZATION_ON_CAR_DEALERSHIPS]:
          'digitalisaation-vaikutus-autoliikkeisiin',
        [ArticleDetailRoutesPath.THE_SEMICONDUCTOR_SHORTAGE_IMPLICATIONS_FOR_THE_AUTOMOTIVE_INDUSTRY]:
          'puolijohdepula-vaikutukset-autoteollisuudelle',
        [ArticleDetailRoutesPath.THE_USED_CAR_MARKET_OPPORTUNITIES_AND_CHALLENGES_FOR_AUTO_PROFESSIONALS]:
          'käytettyjen-autojen-markkinat-mahdollisuudet-ja-haasteet-autoprofeille',
      },
    },
  },
};
